import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'


Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    user: null,
    snackbarMessage: '',
    snackbarColor: undefined,
  },
  mutations: {
    setUser (state, user) {
      state.user = user
    },
    setSnackbarMessage (state, { message }) {
      state.snackbarMessage = message
    },
    setSnackbarColor (state, { color }) {
      state.snackbarColor = color
    }
  },
  actions: {
    showSnackbar ({ commit }, payload) {
      commit('setSnackbarMessage', { message: payload.message })
      if (payload.color) {
        commit('setSnackbarColor', { color: payload.color })
      }
    }
  }
})
